import { isSelfHostedDistribution } from "utils/distribution";
import useSelfHostedFlags from "hooks/useSelfHostedFlags";
import useTypedFlags from "hooks/useTypedFlags";

const isSelfHosted = isSelfHostedDistribution();

/**
 * Whether the refreshed usage data page is enabled for the current account.
 * SaaS reads the flag from LaunchDarkly, self-hosted from the backend evaluated flags.
 */
const useRefreshedUsagePageFlag = () => {
  const { refreshedUsageDataPageFrontend } = useTypedFlags();
  const { refreshedUsageDataPageFrontend: refreshedUsageDataPageFrontendSelfHosted } =
    useSelfHostedFlags();

  return isSelfHosted ? refreshedUsageDataPageFrontendSelfHosted : refreshedUsageDataPageFrontend;
};

export default useRefreshedUsagePageFlag;
